module.exports = __webpack_public_path__ + "static/media/hand.bcf46d65.svg";